// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3hPnQ","paramInput":"JobSimulator_paramInput__gpJrJ","input":"JobSimulator_input__21Jrv"};